import { render } from "./letter-pattern-delete.vue?vue&type=template&id=653d6ca6"
import script from "./letter-pattern-delete.vue?vue&type=script&lang=js"
export * from "./letter-pattern-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__